<template>
  <div class="news_list">
    <ul>
      <li v-for="(img, index) in images2" :key="index">
        <div class="list_inner" v-scroll-reveal="{ delay: 50 }">
          <div class="image">
            <img src="../../assets/img/placeholders/4-3.jpg" alt="thumb" />
            <div
              class="main"
              :style="{ backgroundImage: 'url(' + img + ')' }"
            ></div>
          </div>
          <!-- End image -->

          <!-- <div class="details">
            <h3 class="title" @click="showModal">
              Grilled Chicken Salad
            </h3> -->
            <!-- <p class="date">
              By <a href="#">Alex Watson</a> <span>20 May 2020</span>
            </p> -->
          <!-- </div> -->
          <!-- End details -->
        </div>

      </li>
      <!-- End li -->

   
    </ul>
    <div class="shane_tm_button cursor-pointer" v-scroll-reveal="{ delay: 150 }" v-if="numImages < images.length">
      <a @click="ShowMore()">
        Show More
      </a>
    </div>
    <br/><br/>
    <!-- <button class="dark-fill-bg" @click="ShowMore()">
      Make an enquiry
    </button> -->
  </div>
</template>

<script>
// import Social from "../Social.vue";
export default {
  components: {
    // Social,
  },
  data() {
    return {
      isActive: false,
      isActive2: false,
      isActive3: false,
      isVisible: false,
      isVisible2: false,
      isVisible3: false,
      numImages: 3,
      images: [
        require("@/assets/img/news/insta1.jpg"),
        require("../../assets/img/news/insta2.jpg"),
        require("../../assets/img/news/insta3.jpg"),
        require("../../assets/img/news/insta4.jpg"),
        require("../../assets/img/news/insta5.jpg"),
        require("../../assets/img/news/insta6.jpg"),
        require("../../assets/img/news/insta7.jpg"),
        // require("../../assets/img/news/insta8.jpg"),
        require("../../assets/img/news/insta9.jpg"),
        require("../../assets/img/news/insta10.jpg"),
        require("../../assets/img/news/insta11.jpg"),
        require("../../assets/img/news/insta12.jpg"),
      ],
    };
  },
  methods: {
    ShowMore() {
      this.numImages += 3
    },
    showModal: function() {
      this.isActive = true;
      this.isVisible = true;
    },
    showModal2: function() {
      this.isActive2 = true;
      this.isVisible2 = true;
    },
    showModal3: function() {
      this.isActive3 = true;
      this.isVisible3 = true;
    },
    closeModal: function() {
      this.isActive = false;
      this.isVisible = false;
    },
    closeModal2: function() {
      this.isActive2 = false;
      this.isVisible2 = false;
    },
    closeModal3: function() {
      this.isActive3 = false;
      this.isVisible3 = false;
    },
  },
  computed: {
    images2() {
      let x = []
      let n = this.numImages
      if (this.numImages > this.images.length) {
        n = this.images.length
      }
      for (let i = 0; i < n; i += 1) {
        x.push(this.images[i])
      }
      return x
    }
  }
};
</script>

<style lang="scss" scoped></style>
